var SuggestionTypes = {
    WordSearch: 'WordSearch',
    History: 'History',
    Entity: 'Entity',
    Partner: 'Partner'
};

export { SuggestionTypes };
